/* Copyright (c) 2017 Backpack Health LLC */
/* global window */

import { connect } from 'react-redux';
import * as _ from 'lodash';

import GroupJoinInstructions, { GroupJoinInstructionsProps } from './GroupJoinInstructions';
import RouteNames from '../../../appAuthorized/RouteNames';
import { selectors as groupSelectors, actions as groupActions } from '../../../redux/ducks/group';
import { joinGroupIntent } from '../../../../utilities/LocalStorage';
import { TrackEvent } from '../../../../utilities/UserMetrics';
import { navigateGoBack } from '../../../appAuthorized/redux/NavigationActions';

function mapStateToProps(state, routerProps): Partial<GroupJoinInstructionsProps>  {
  const subdomain = _.get(routerProps, 'match.params.group', '').toLowerCase();
  const groupMetadata = groupSelectors.getGroupBySubdomain(state, subdomain);
  return {
    groupMetadata,
    subdomain,
    activeGroupId: groupSelectors.getActiveGroupId(state),
    isRequestFailed: groupSelectors.getIsRequestGroupFailed(state),
    goToJoinGroup: (groupData, u, lang) => {
      TrackEvent.groupJoinInstructions.joinGroup(groupData.name);

      const langParam = lang ? `?lang=${lang}` : '';
      // for unauth page need to save group id to record intent later
      joinGroupIntent.push(groupData.id);

      const url = `${window.location.origin}${RouteNames.signupIntro()}${langParam}`;
      window.open(url);
    },
    goBack: () => {
      navigateGoBack(RouteNames.login());
    },
  };
}

function mapDispatchToProps(dispatch): Partial<GroupJoinInstructionsProps>  {
  return {
    fetchGroup: (subdomain) => {
      dispatch(groupActions.requestGroupBySubdomain(subdomain));
    },
    setActiveGroup: (groupId, activeGroupId) => {
      if (groupId !== activeGroupId) {
        dispatch(groupActions.setActiveGroup(groupId));
      }
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupJoinInstructions);
